import { QueryClient } from '@tanstack/react-query'

// Create a single query client instance
// Exported from a separate file to avoid breaking React Fast Refresh in route components
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 1, // 1 minutes - data is considered fresh for this duration
      gcTime: 1000 * 60 * 5, // 5 minutes - cache is kept in memory for this duration
      refetchOnWindowFocus: false,
      retry: false, // Disable automatic retries for queries
    },
    mutations: {
      retry: false, // Disable automatic retries for mutations
    },
  },
})
